<ng-container *transloco="let t; read: scope">
  <button class="button-classes" type="button" id="accessible_intercom_launcher">
    <div class="margin-icon">
      <rma-icon glyph="chat" />
    </div>
    {{ t('help') }}
  </button>
</ng-container>
